module.exports = __webpack_public_path__ + "static/media/tower_shield.94f0e13c.png";